import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import ChatListItem from "./ChatListItem.jsx";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 0,
    overflowY: "auto",
  },
}));

/** */
const ChatListContent = () => {
  const classes = useStyles();
  const { filteredConversations } = useChat();

  if (!filteredConversations) return null;

  return (
    <Box className={classes.root}>
      {filteredConversations.map((it) => (
        <ChatListItem key={it.id} data={it} />
      ))}
    </Box>
  );
};

export default ChatListContent;
